export default __webpack_public_path__ + "static/media/ICON_Products.2665f50f.svg";